module.exports = __webpack_public_path__ + "img/hos.d2715465.jpg";